import Api from "../../../../services/Api";

function fetchFleetSearchDetails() {
  return Api.post("/service/evse_controller/api/v1/query/ev_charger", {
    is: { protocol: "OCPP", isRetired: false },
  });
}

export { fetchFleetSearchDetails };
